<template>
  <Head title="Login" />
  <div class="flex items-center justify-center p-6 min-h-screen bg-indigo-800">
    <div class="w-full max-w-md">
<!--      <logo class="block mx-auto w-full max-w-xs fill-white" height="50" />-->

      <img class="block mx-auto max-w-xs fill-white" src="/logo-login.jpg" alt="Logo">
      <form class="mt-8 bg-white rounded-lg shadow-xl overflow-hidden" @submit.prevent="login">
        <div class="px-10 py-12">
          <h1 class="text-center text-3xl font-bold">Mirësevini!</h1>
          <div class="mt-6 mx-auto w-24 border-b-2" />
          <text-input v-model="form.email" :error="form.errors.email" class="mt-10" label="Email" type="email" autofocus autocapitalize="off" />
          <text-input v-model="form.password" :error="form.errors.password" class="mt-6" label="Password" type="password" />
          <label class="flex items-center mt-6 select-none" for="remember">
            <input id="remember" v-model="form.remember" class="mr-1" type="checkbox" />
            <span class="text-sm">Më mbaj mend</span>
          </label>
        </div>
        <div class="block items-center px-10 py-4 bg-gray-100 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo mb-1" type="submit">Kyqu</loading-button>
<!--          <hr v-if="env !== 'production'" />-->
<!--          <loading-button v-if="env !== 'production'" :loading="form.processing" class="btn-indigo mb-1 mt-1" type="submit" @click.stop.prevent="loginAsSuperadmin()">Kyqu si superadmin</loading-button>-->
<!--          <loading-button v-if="env !== 'production'" :loading="form.processing" class="btn-indigo mb-1" type="submit" @click.stop.prevent="loginAsAdmin()">Kyqu si admin</loading-button>-->
<!--          <loading-button v-if="env !== 'production'" :loading="form.processing" class="btn-indigo mb-1" type="submit" @click.stop.prevent="loginAsSeller()">Kyqu si shites</loading-button>-->
<!--          <loading-button v-if="env !== 'production'" :loading="form.processing" class="btn-indigo mb-1" type="submit" @click.stop.prevent="loginAsCollectingDriver()">Kyqu si shofer mbledhes</loading-button>-->
<!--          <loading-button v-if="env !== 'production'" :loading="form.processing" class="btn-indigo mb-1" type="submit" @click.stop.prevent="loginAsDeliveryDriver()">Kyqu si shofer shperndares</loading-button>-->
<!--          <loading-button v-if="env !== 'production'" :loading="form.processing" class="btn-indigo mb-1" type="submit" @click.stop.prevent="loginAsWarehouseman()">Kyqu si depoist</loading-button>-->
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import {Head, usePage} from '@inertiajs/inertia-vue3'
import Logo from '@/Shared/Logo'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import {computed} from 'vue'

export default {
  components: {
    Head,
    LoadingButton,
    Logo,
    TextInput,
  },
  data() {
    return {
      form: this.$inertia.form({
        email: null,
        password: null,
        remember: false,
      }),
    }
  },
  methods: {
    login() {
      this.form.post('/login')
    },
    loginAsSuperadmin(){
      this.form.email = 'superadmin@gmail.com'
      this.form.password = 'password'
      this.form.post('/login')
    },
    loginAsAdmin(){
      this.form.email = 'admin@gmail.com'
      this.form.password = 'password'
      this.form.post('/login')
    },
    loginAsSeller(){
      this.form.email = 'shites@gmail.com'
      this.form.password = 'password'
      this.form.post('/login')
    },
    loginAsDeliveryDriver(){
      this.form.email = 'shofershperndares@gmail.com'
      this.form.password = 'password'
      this.form.post('/login')
    },
    loginAsCollectingDriver(){
      this.form.email = 'shofermbledhes@gmail.com'
      this.form.password = 'password'
      this.form.post('/login')
    },
    loginAsWarehouseman(){
      this.form.email = 'depoist@gmail.com'
      this.form.password = 'password'
      this.form.post('/login')
    },
  },
  setup() {
    const env = computed(() => usePage().props.value.environment.env)
    return {env}
  },
}
</script>
